import { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  FormHelperText,
} from "@mui/material";

const CreateCategoryDialog = ({ open, onClose, onSubmit, parentId = null }) => {
  const [name_ar, setNameAr] = useState("");
  const [name_en, setNameEn] = useState("");
  const [desc_ar, setDescAr] = useState("");
  const [desc_en, setDescEn] = useState("");
  const [status, setStatus] = useState("active");
  const [image, setImage] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!open) {
      setNameAr("");
      setNameEn("");
      setDescAr("");
      setDescEn("");
      setStatus("active");
      setImage(null);
      setError(null);
      setSubmitting(false);
    }
  }, [open]);

  const handleSave = async () => {
    setError(null);
    if (!name_ar && !name_en) {
      setError("Please provide name_ar or name_en");
      return;
    }
    const formData = new FormData();
    formData.append("name_ar", name_ar);
    formData.append("name_en", name_en);
    formData.append("desc_ar", desc_ar);
    formData.append("desc_en", desc_en);
    formData.append("status", status);
    if (image) formData.append("image", image);
    // include parent id when creating subcategory
    if (parentId !== null && parentId !== undefined) {
      formData.append("category_id", String(parentId));
    }

    try {
      setSubmitting(true);
      await onSubmit(formData);
      onClose && onClose();
    } catch (err) {
      setError(err?.message || "Error submitting category");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={() => !submitting && onClose && onClose()} maxWidth="sm" fullWidth>
      <DialogTitle>{parentId ? "إضافة فئة فرعية" : "إضافة فئة جديدة"}</DialogTitle>
      <DialogContent>
        <Box sx={{ display: "grid", gap: 2, mt: 1 }}>
          <TextField label="الاسم (عربي)" value={name_ar} onChange={(e) => setNameAr(e.target.value)} fullWidth />
          <TextField label="الاسم (EN)" value={name_en} onChange={(e) => setNameEn(e.target.value)} fullWidth />
          <TextField label="الوصف (عربي)" value={desc_ar} onChange={(e) => setDescAr(e.target.value)} fullWidth multiline minRows={2} />
          <TextField label="الوصف (EN)" value={desc_en} onChange={(e) => setDescEn(e.target.value)} fullWidth multiline minRows={2} />
          <FormControl>
            <InputLabel id="cat-status-label">الحالة</InputLabel>
            <Select labelId="cat-status-label" value={status} label="الحالة" onChange={(e) => setStatus(e.target.value)}>
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="inactive">Inactive</MenuItem>
            </Select>
          </FormControl>
          <Box>
            <input id="cat-image" type="file" accept="image/*" onChange={(e) => setImage(e.target.files?.[0] || null)} />
            <FormHelperText>Optional image</FormHelperText>
          </Box>
          {error ? <Box sx={{ color: "error.main", fontSize: 13 }}>{error}</Box> : null}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => !submitting && onClose && onClose()}>إلغاء</Button>
        <Button variant="contained" onClick={handleSave} disabled={submitting}>
          {submitting ? <CircularProgress size={20} /> : "حفظ"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateCategoryDialog;
